<!-- 
  ColumnBox.vue
  사용법:
  
  <ColumnBox vAlign="top" hAlign="left">
    <div>Item</div>
  </ColumnBox>

  Props:
    vAlign : "top" | "center" | "bottom"       → 수직 정렬 (justify-content)
    hAlign : "left" | "center" | "right"       → 수평 정렬 (align-items)
-->

<template>
  <div :class="classes">
    <slot />
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  vAlign: {
    type: String,
    default: "center",
    validator: (v) => ["top", "center", "bottom"].includes(v),
  },
  hAlign: {
    type: String,
    default: "center",
    validator: (v) => ["left", "center", "right"].includes(v),
  },
});

const verticalMap = {
  top: "valign-top",
  center: "valign-center",
  bottom: "valign-bottom",
};

const horizontalMap = {
  left: "halign-left",
  center: "halign-center",
  right: "halign-right",
};

const classes = computed(() => [
  "colBox",
  verticalMap[props.vAlign],
  horizontalMap[props.hAlign],
]);
</script>

<style scoped>
.colBox {
  display: flex;
  flex-direction: column;
}

/* Vertical alignment (justify-content) */
.valign-top {
  justify-content: flex-start;
}
.valign-center {
  justify-content: center;
}
.valign-bottom {
  justify-content: flex-end;
}

/* Horizontal alignment (align-items) */
.halign-left {
  align-items: flex-start;
}
.halign-center {
  align-items: center;
}
.halign-right {
  align-items: flex-end;
}
</style>
